export default __webpack_public_path__ + "media/guidelines/video-7b993315.png";